import { createContext } from 'react';

import { TAiReviewDto } from '@app-velocity/av-api-v2'

export type AIReviewStatusContextType = {
    review: TAiReviewDto;
}

export const AIReviewStatusContext = createContext<AIReviewStatusContextType>({
    review: {}
})